import {
    put,
    select,
    all,
} from 'redux-saga/effects';
import {
    setDefaultStateSuccess,
    getRoamingOptionsSuccess,
} from '../action';

import {
    selectSelectedCountry,
    selectSelectedDestination,
    roamingOptionVOs,
    selectCountries,
} from '../selector';

import markupSelector from './markupSelector';

import countries from '../../../fixtures/countries';

import { getRaLocale } from '../utils/getLocale';

/**
 * callGetCountriesSaga
 */
export function* callGetCountriesSaga () {
    const sortedCountreis = countries.sort((a, b) => a.name.localeCompare(b.name));

    yield put(setDefaultStateSuccess(sortedCountreis));
}

/**
 * callGetRoamingOptionsSaga
 */
export function* callGetRoamingOptionsSaga (args) {
    // get country and destination since this is not part of the arguments
    const [selectedCountry, selectedDestination, allCountries] = yield all([
        select(selectSelectedCountry()),
        select(selectSelectedDestination()),
        select(selectCountries()),
    ]);

    const filteredOptons = markupSelector(allCountries, selectedDestination, selectedCountry, args.tariff);

    const roamingOptions = roamingOptionVOs(filteredOptons);

    if (roamingOptions.length === 0) {
        roamingOptions.push({
            title: getRaLocale('headlineNothingFound'),
            description: getRaLocale('textNothingFound'),
        });
    }

    yield put(getRoamingOptionsSuccess(roamingOptions));
}
